import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import thinkAIIcon from '../assets/ThinkAI logo.png';
import marketResearchIcon from '../assets/MARS logo.png';
import daasIcon from '../assets/DAAS logo.png';

const ProductsGrid = () => {
  const navigate = useNavigate();
  const titleRef = useRef(null);
  const cardsRef = useRef([]);

  const products = [
    {
      icon: thinkAIIcon,
      title: "ThinkAI",
      description:
        "A state-of-the-art platform designed to revolutionize business data analytics by providing a centralized hub for accessing analytics tools, leveraging advanced data science and machine learning for near real-time insights, with dashboards and interactive reports to enhance decision-making to optimize operations.",
      // NEW: multiple buttons for ThinkAI
      buttons: [
        { text: "Explore Financial Analytics", path: "/thinkfinance" },
        { text: "Explore HR Analytics", path: "/thinkHR" }
      ],
      iconClass: "mars-icon"
    },
    {
      icon: marketResearchIcon,
      title: "Market Research",
      description:
        "We provide a customized analysis for your business's competitive landscape, integrating various data sources to offer a comprehensive market overview. This approach ensures you receive actionable insights directly relevant to your industry, empowering strategic decision-making for a competitive advantage.",
      // old shape still works
      buttonText: "Explore MARS",
      path: "/marketresearch",
      iconClass: "mars-icon"
    },
    {
      icon: daasIcon,
      title: "Data Analytics & Solutions",
      description:
        "Get access to highly skilled data analysts who can seamlessly integrate into your project teams, driving forward with fresh perspectives and intelligence. We offer targeted analytics-based projects that match your business needs.",
      buttonText: "Explore DAAS",
      path: "/daas",
      iconClass: "daas-icon"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('animate-in');
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    cardsRef.current.forEach(card => { if (card) observer.observe(card); });

    return () => observer.disconnect();
  }, []);

  const handleExplore = (path) => {
    if (!path) return;
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div ref={titleRef} className="products-solutions-title fade-in-up">
        Products &amp; Solutions
      </div>

      <div className="main-products-grid">
        {products.map((product, index) => {
          // Compatibility: use product.buttons if present; otherwise build a single-button array
          const buttons =
            Array.isArray(product.buttons) && product.buttons.length
              ? product.buttons
              : (product.buttonText && product.path
                  ? [{ text: product.buttonText, path: product.path }]
                  : []);

          return (
            <div
              className="main-product-card slide-in-up"
              key={product.title}
              ref={el => (cardsRef.current[index] = el)}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="main-product-icon">
                <img
                  src={product.icon}
                  alt={product.title}
                  className={product.iconClass}
                />
              </div>

              <h3 className="main-product-card-title">{product.title}</h3>
              <p className="main-product-card-description">{product.description}</p>

              {/* Buttons */}
              <div className="main-product-card-buttons">
                {buttons.map((btn, i) => (
                  <button
                    key={`${product.title}-btn-${i}`}
                    onClick={() => handleExplore(btn.path)}
                    className="main-product-card-button"
                  >
                    {btn.text}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ProductsGrid;
